<div class="wrapper">
  <div class="tools">
    @if (!hideSetDimensions) {
      <div class="field-group">
        <mat-form-field id="mat-width-field" class="mat-width-field">
          <mat-label>Width</mat-label>
          <input matInput [(ngModel)]="internalCropWidth" type="number" name="width"
            placeholder="width" [disabled]="lockDimensions" required
            mgdEnhancedControl #widthControl="mgdEnhancedControl"/>
          <mgd-clear-button matSuffix [formField]="widthControl"/>
          <mat-error><mgd-error-message [formField]="widthControl"/></mat-error>
        </mat-form-field>
        <mat-form-field id="mat-height-field" class="mat-height-field">
          <mat-label>Height</mat-label>
          <input matInput [(ngModel)]="internalCropHeight" type="number" name="height"
            placeholder="height" [disabled]="lockDimensions" required
            mgdEnhancedControl #heightControl="mgdEnhancedControl"/>
          <mgd-clear-button matSuffix [formField]="heightControl"/>
          <mat-error><mgd-error-message [formField]="heightControl"/></mat-error>
        </mat-form-field>
      </div>
    }
    <div class="icon-group">
      @if (!hideSetDimensions) {
        <button id="mat-lock-dimensions-icon-button" class="mat-toolbar-icon-button" [class.mat-locked-icon-button]="lockDimensions" mgdButton mat-icon-button matTooltip="{{lockDimensions ? 'Lock' : 'Unlock'}} Output Size" matTooltipPosition="above" (click)="onLockClick()">
          <mat-icon class="mat-icon-lock-unlock">
            @if (lockDimensions) {
              lock
            }
            @else {
              lock_open
            }
          </mat-icon>
        </button>
      }
      <button class="mat-toolbar-icon-button" mgdButton mat-icon-button matTooltip="Rotate image 90°" matTooltipPosition="above" (click)="onRotateClick($event)">
        <mat-icon>autorenew</mat-icon>
      </button>
      <button class="mat-toolbar-icon-button" mgdButton mat-icon-button matTooltip="Zoom out" matTooltipPosition="above" (click)="onZoomOutClick($event)">
        <mat-icon>zoom_out</mat-icon>
      </button>
      <button class="mat-toolbar-icon-button" mgdButton mat-icon-button matTooltip="Zoom in" matTooltipPosition="above" (click)="onZoomInClick($event)">
        <mat-icon>zoom_in</mat-icon>
      </button>
    </div>

  </div>

  <div class="cropper-js-wrapper">
    <img #image alt="crop image" class="initial-image" crossorigin="anonymous" [src]="safeImageUrl" />
  </div>
</div>
